function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M344.385 429V280.299H167.068V429h-59.787V88.163h59.787v139.503h177.317V88.163h59.787V429z",
  fillRule: "evenodd"
});

const SvgHeading = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512",
  ref: svgRef
}, props), _ref);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeading, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/heading.7385821c.svg";
export { ForwardRef as ReactComponent };